
const wrap = (element, wrapper) => {
    element.parentNode.insertBefore(wrapper, element);
    wrapper.appendChild(element);
  
    return wrapper;
};

document.addEventListener('DOMContentLoaded', () => {
    const screenWidth = window.matchMedia("(max-width: 767px)");

    // if (screenWidth.matches) {
    //     //mobile
    //     const productWrappers = document.querySelectorAll(".product-card__wrapper");

    //     for ( let product of productWrappers ) {
    //         // make PDP redirect link 0x0px
    //         const productLink = product.querySelector('.product-card__link');
    //         let productHandle = null;
    //         if ( productLink != null ) {
    //             productLink.style.bottom = 'unset';
    //             productLink.style.right = 'unset';
    //             productHandle = productLink.href.replace('https://lillap.com/products/', "");
    //         }

    //         // add quickview button to image and title
    //         const quickviewButton = document.createElement('div');
    //         quickviewButton.setAttribute('data-product-quickview', productHandle);
    //         quickviewButton.style.cursor = 'pointer'

    //         const imageWrapper = product.querySelector('.product-card__image-wrapper');
    //         if ( imageWrapper != null ) {
    //             wrap(imageWrapper, quickviewButton)
    //         }
    //         const title = product.querySelector('.product-card__title');
    //         if ( title != null ) {
    //             wrap(title, quickviewButton)
    //         }

    //         // remove PDP redirect on colors
    //         const swatches = product.querySelectorAll(".swatch-list-item.mobile-swatch");
            
    //         for ( let swatch of swatches ) {
    //             const mobileDiv = swatch.querySelector('.mobile-div');

    //             if ( mobileDiv != null ) {
                    
    //                 const colorName = mobileDiv.querySelector('.sr-only').innerHTML
    //                 if ( colorName != null ) {
    //                     mobileDiv.style.marginTop = "-1px";
    //                     mobileDiv.style.marginLeft = "-1px";

    //                     const swatchQuickviewButton = document.createElement('div');
    //                     swatchQuickviewButton.setAttribute('data-product-quickview', `${productHandle}?variant-color=${colorName.replaceAll(" ", "_")}`);
    //                     swatchQuickviewButton.style.cursor = 'pointer';
    
    //                     wrap(mobileDiv, swatchQuickviewButton)
    //                 }
    //             }

                
                
    //         }

    //         // add quickview button to colors to open quick view with same color selected
    //     }
    // } else {
    //     // desktop
    // }
})

